export const isRequired = (value: string, errorMessage?: string) => {
    const usedErrorMessage = errorMessage || 'This field is required'
    return (value == null || value.length === 0) ? usedErrorMessage: null
}

export const isSet = (target: string, value: string) => value !== undefined && value.length > 0

export const hashCode = (input: string): number => {
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
        const code = input.charCodeAt(i);
        hash = ((hash<<5)-hash)+code;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
